const name = "cpf_cnpj";

const filter = v => {
  let vet = v;

  if (vet) {
    if (vet.length == 11) {
      //Coloca um ponto entre o terceiro e o quarto dígitos
      vet = vet.replace(/(\d{3})(\d)/, "$1.$2");

      //Coloca um ponto entre o terceiro e o quarto dígitos
      //de noveto (para o segundo bloco de números)
      vet = vet.replace(/(\d{3})(\d)/, "$1.$2");

      //Coloca um hífen entre o terceiro e o quarto dígitos
      vet = vet.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
    } else if (vet.length == 14) {
      //Coloca ponto entre o segundo e o terceiro dígitos
      vet = vet.replace(/^(\d{2})(\d)/, "$1.$2");

      //Coloca ponto entre o quinto e o sexto dígitos
      vet = vet.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");

      //Coloca uma barra entre o oitavo e o nono dígitos
      vet = vet.replace(/\.(\d{3})(\d)/, ".$1/$2");

      //Coloca um hífen depois do bloco de quatro dígitos
      vet = vet.replace(/(\d{4})(\d)/, "$1-$2");
    }
  }
  return vet;
};

const params = { name, filter };

export default params;
